export default __webpack_public_path__ + "static/media/arrow-right-v2.ba704c14431cceff59e3956dad4a047e.svg";